var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.item)?_c('div',{staticClass:"no-padding"},[_c('memlist-text-input',{attrs:{"id":"confirm_text_box","name":"confirm_text_box","title":_vm.item.name,"layout":"vertical","size":"lg"},model:{value:(_vm.input_text),callback:function ($$v) {_vm.input_text=$$v},expression:"input_text"}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }